"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useReducedMotion } from "framer-motion";
import { type ReactNode } from "react";
import { cn } from "@/shared/lib/utils";
type MaskedLinesProps = {
  lines: ReactNode[];
  start?: boolean;
  startDelay?: number;
  className?: string;
};

// Each line is clipped by an overflow-hidden row; the inner span rises from
// below into place, one after another — the classic masked headline reveal.
export const MaskedLines = t0 => {
  const $ = _c(14);
  const {
    lines,
    start: t1,
    startDelay: t2,
    className
  } = t0;
  const start = t1 === undefined ? true : t1;
  const startDelay = t2 === undefined ? 0 : t2;
  const reduce = useReducedMotion();
  let t3;
  if ($[0] !== className) {
    t3 = cn("block", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== lines || $[3] !== reduce || $[4] !== start || $[5] !== startDelay) {
    let t5;
    if ($[7] !== reduce || $[8] !== start || $[9] !== startDelay) {
      t5 = (line, i) => <span key={i} className="block overflow-hidden pb-[0.12em]"><motion.span className="block" initial={reduce ? false : {
          y: "115%"
        }} animate={start ? {
          y: 0
        } : {
          y: "115%"
        }} transition={{
          duration: 0.8,
          delay: startDelay + i * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }}>{line}</motion.span></span>;
      $[7] = reduce;
      $[8] = start;
      $[9] = startDelay;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = lines.map(t5);
    $[2] = lines;
    $[3] = reduce;
    $[4] = start;
    $[5] = startDelay;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};